import {SHOW_NOTIFICATION, RESET_NOTIFICATION} from '../actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return action.payload;
    case RESET_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};
